import { PaginatedResult } from "@/interfaces/common/PaginatedResult";
import { Product } from "@/interfaces/domain/Product";
import { Store } from "@/interfaces/domain/Store";
import { api } from "@/services/api";

export type PaginatedSearch = {
  produtos: Product[];
} & Omit<PaginatedResult<Product>, "docs">;

export type SearchStoresOrProductsResponse = {
  estabelecimentos: Store[];
  produtos: Product[];
  total: number;
};

export async function searchStoresOrProducts(
  query: string,
  limit?: number
): Promise<SearchStoresOrProductsResponse> {
  const response = await api.get<PaginatedSearch>(`/buscar/v2/produtos/${query}?limit=${limit}`);
  const { produtos, total } = response.data;
  const estabelecimentosobjects: { [key: string]: Store } = {};

  produtos.forEach((produto) => {
    const estabelecimento = produto.estabelecimento as Store;
    if (estabelecimento) {
      estabelecimentosobjects[estabelecimento._id] = estabelecimento;
    }
  });

  const estabelecimentos = Object.values(estabelecimentosobjects).sort((a, b) =>
    a.status < b.status ? -1 : 1
  );

  return {
    estabelecimentos,
    produtos,
    total,
  };
}

export async function searchStoreProducts({
  query,
  storeId,
  limit,
  page,
}: {
  storeId: string;
  query: string;
  page?: number;
  limit?: number;
}): Promise<PaginatedSearch> {
  const { data } = await api.get<PaginatedSearch>(
    `/buscar/v2/estabelecimento/${storeId}/produtos/${query}?page=${page}&limit=${limit}`
  );
  return data;
}
